import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.link";
import _createForOfIteratorHelper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
 微信接口模块
 */
import config from './config';
import tenvideo from './tenvideo';
import RetCode from './retcode';
import util from './util';
import { createNormalizer } from './urlFactory'; // var wx = window.wx || {};

var ua = navigator.userAgent;
var normalizer = createNormalizer();
var WX_APP_ID = 'wx68ff4e3ba9f84df4'; // 微信公众号appId

var APP_APP_ID = 'wxca942bbff22e0e51'; // 腾讯视频appId
// const IPAD_APP_ID = "wxcfbccf1c9c3e2a16"; //腾讯视频HD appId

/* eslint camelcase: ["error", {properties: "never"}] */

function init(callback) {
  util.loadScript('jweixin', '//res.wx.qq.com/open/js/jweixin-1.6.0.js', function () {
    getSign(function (json) {
      if (json) {
        wx.ready(function () {
          window.HLW_WeixinJSReady = true;
          callback && callback({
            ready: 1
          });
        });
        wx.error(function () {
          callback && callback({
            ready: 0
          });
        });
        wx.config({
          beta: true,
          // 必填，开启内测接口调用，注入wx.invoke和wx.on方法
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: WX_APP_ID,
          // 必填，公众号的唯一标识
          timestamp: json.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: json.nonceStr,
          // 必填，生成签名的随机串
          signature: json.signature,
          // 必填，签名，见附录1
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'closeWindow', 'chooseWXPay', 'setPageTitle', 'launchApplication', 'getLocation']
        });
      }
    });
  });
}
/**
 * 获取JSAPI签名
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */


function getSign(callback, retryCount) {
  var retObj = new RetCode('pay.video.qq.com', 'jssign');
  $.ajax({
    url: '//pay.video.qq.com/fcgi-bin/jssign?otype=json',
    dataType: 'jsonp',
    cache: false,
    data: {
      url: location.href
    },
    beforeSend: function beforeSend() {
      retObj.begin();
    }
  }).done(function (json) {
    if (json && json.result) {
      if (json.result.code === 0) {
        retObj.reportSuc();
        callback && callback(json);
      } else {
        retObj.reportLogicErr(json.result.code);
        callback && callback();
      }
    } else {
      retObj.reportLogicErr();
      callback && callback();
    }
  }).fail(function () {
    if (!retryCount || retryCount < 2) {
      retryCount = retryCount || 0;
      getSign(callback, retryCount + 1);
    } else {
      retObj.reportErr();
      callback && callback();
    }
  });
} // 获取分享APP名称


function getShareTo(res) {
  var arrMsg = res.errMsg.split(':');
  var name = arrMsg[0];
  var shareTo = '';

  switch (name) {
    case 'sendAppMessage':
      shareTo = 'friend';
      break;

    case 'shareTimeline':
      shareTo = 'timeline';
      break;

    case 'shareWeiboApp':
      shareTo = 'weibo';
      break;

    case 'shareQQ':
      shareTo = 'qq';
      break;

    case 'shareQZone':
      shareTo = 'qzone';
      break;
  }

  return shareTo;
}

function verCompare(v1, v2) {
  if (v1 === v2) return 0;
  v1 = v1.split('.');
  v2 = v2.split('.');
  var len = v1.length >= v2.length ? v1.length : v2.length;
  var i = 0;
  var r = 0;

  while (len--) {
    var c1 = Number(v1[i] || 0);
    var c2 = Number(v2[i++] || 0);

    if (c2 > c1) {
      return 1;
    } else if (c2 < c1) {
      return -1;
    }
  }

  return r;
}
/* eslint camelcase: ["off"] */


var lock_ready = false;
var arr_callback = [];
export default {
  /**
   * JSAPI Ready
   * @param  {[type]} callback [description]
   * @return {[type]}     [description]
   */
  weixinReady: function weixinReady(callback) {
    callback = callback || function () {};

    if (typeof HLW_WeixinJSReady === 'undefined') {
      arr_callback.push(callback);

      if (!lock_ready) {
        lock_ready = true;
        init(function () {
          lock_ready = false;

          var _iterator = _createForOfIteratorHelper(arr_callback),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var fun = _step.value;
              fun && fun();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          arr_callback = [];
        });
      }
    } else {
      callback && callback();
    }
  },

  /**
   * WeixinJSBridgeReady
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  WeixinJSBridgeReady: function WeixinJSBridgeReady(fun) {
    fun = fun || function () {};

    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', fun, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', fun);
      }
    } else {
      fun();
    }
  },

  /**
   * 是否微信环境
   */
  isWeiXin: function isWeiXin() {
    return ua.indexOf('MicroMessenger') >= 0;
  },

  /**
   * 设置分享
   * @param {[type]}
   */
  setShare: function setShare(shareObj) {
    var self = this;
    var _shareObj = {
      title: shareObj.title || '腾讯视频VIP影院',
      // 分享标题
      desc: shareObj.desc || '享受更好的，因为我是VIP',
      // 分享描述
      link: normalizer(shareObj.link || document.location.toString().replace(/[?&#](code|state|timestamp)=[^&#]+/gi, ''), false),
      // 分享链接
      imgUrl: normalizer(shareObj.imgUrl || '//puui.qpic.cn/vupload/0/1575447197802_m1krxk6ieeo.png/0', false),
      // 分享图标
      success: function success(res) {
        // 用户确认分享后执行的回调函数
        res.app = 'wechat';
        res.shareTo = getShareTo(res);

        if (shareObj.success) {
          shareObj.success(res);
        } else if (shareObj.shareHandler) {
          shareObj.shareHandler(res);
        }
      },
      cancel: function cancel(res) {
        // 用户取消分享后执行的回调函数
        res.app = 'wechat';
        res.shareTo = getShareTo(res);

        if (shareObj.cancel) {
          shareObj.cancel(res);
        }
      }
    };
    this.weixinReady(function () {
      self.showOptionMenu(); // 分享到朋友圈

      if (shareObj.timeLineTitle) {
        wx.onMenuShareTimeline(Object.assign({}, _shareObj, {
          title: shareObj.timeLineTitle
        }));
      } else {
        wx.onMenuShareTimeline(_shareObj);
      } // 分享给朋友


      wx.onMenuShareAppMessage(_shareObj); // 分享到QQ

      wx.onMenuShareQQ(_shareObj); // 分享到腾讯微博

      wx.onMenuShareWeibo(_shareObj); // 分享到QQ空间

      wx.onMenuShareQZone(_shareObj);
    });
  },

  /**
   * 隐藏工具栏
   */
  hideToolbar: function hideToolbar() {
    this.weixinReady(function () {
      try {
        window.WeixinJSBridge && WeixinJSBridge.call('hideToolbar');
      } catch (e) {
        void 0;
      }
    });
  },

  /**
   * 显示工具栏
   */
  showToolbar: function showToolbar() {
    this.weixinReady(function () {
      try {
        // 没有这个接口了
        window.WeixinJSBridge && WeixinJSBridge.call('showToolbar');
      } catch (e) {
        void 0;
      }
    });
  },

  /**
   * 隐藏右上角按钮
   */
  hideOptionMenu: function hideOptionMenu() {
    this.weixinReady(function () {
      wx.hideOptionMenu();
    });
  },

  /**
   * 显示右上角按钮
   */
  showOptionMenu: function showOptionMenu() {
    this.weixinReady(function () {
      wx.showOptionMenu();
    });
  },
  showMenuItems: function showMenuItems(menuItems) {
    this.weixinReady(function () {
      wx.showMenuItems({
        menuList: menuItems
      });
    });
  },
  hideMenuItems: function hideMenuItems(menuItems) {
    this.weixinReady(function () {
      wx.hideMenuItems({
        menuList: menuItems
      });
    });
  },
  hideAllNonBaseMenuItem: function hideAllNonBaseMenuItem() {
    this.weixinReady(function () {
      wx.hideAllNonBaseMenuItem();
    });
  },

  /**
   * 关闭窗口
   */
  closeWindow: function closeWindow() {
    this.weixinReady(function () {
      wx.closeWindow();
    });
  },

  /**
   * 获取OAuth Code
   * @param  {[type]} 回跳URL
   * @param  {[type]}
   * @param  {[type]} 类型
   */
  getCode: function getCode(url, state, type) {
    var rUrl = url || location.href;
    type = type || 1;
    rUrl = rUrl.replace(/[?&#](code|state|timestamp)=[^&#]+/gi, '').replace('#rd', '');

    if (rUrl.indexOf('?') !== -1) {
      rUrl += "&timestamp=".concat(new Date().valueOf());
    } else {
      rUrl += "?timestamp=".concat(new Date().valueOf());
    }

    if (!!state === false) {
      state = '1';
    }

    var wxappid = config.wxappid;
    var scope = type === 1 ? 'snsapi_base' : 'snsapi_userinfo';
    url = ['https://open.weixin.qq.com/connect/oauth2/authorize?appid=', wxappid, '&redirect_uri=', encodeURIComponent(rUrl), '&response_type=code&scope=', scope, '&state=', state, '#wechat_redirect'].join('');
    document.location.href = url; // return false;
  },

  /**
   * 获取微信用户AccessToken
   * @param {} param {code:''} 鉴权code
   * @param {} sucCb 成功回调
   * @param {} failCb 失败回调
   */
  getAccessToken: function getAccessToken(param, sucCb, failCb) {
    var data = {};

    if (typeof param === 'string') {
      data.code = param;
    } else {
      if (param.code) {
        data.code = param.code;
      }

      if (param.vuser) {
        data.isgetvuticket = 1;
      }
    }

    var USERINFO_JSON = {
      openid: '',
      access_token: '',
      refresh_token: ''
    };
    $.ajax({
      url: [config.payCgiBaseUrl, 'wx_getopenid?otype=json'].join(''),
      dataType: 'jsonp',
      cache: false,
      data: data
    }).done(function (json) {
      if (json && json.result) {
        if (json.result.code === 0) {
          USERINFO_JSON = {
            openid: json.openid,
            access_token: json.accessToken,
            refresh_token: json.refreshToken
          };
          sucCb && sucCb(USERINFO_JSON);
        } else {
          failCb && failCb(json.result.code);
        }
      } else {
        failCb && failCb(-404);
      }
    }).fail(function () {
      failCb && failCb(-404);
    });
  },

  /**
   * 获取微信用户信息
   * @param {} param {code:''} 鉴权code
   * @param {} sucCb 成功回调
   * @param {} failCb 失败回调
   */
  getUserInfo: function getUserInfo(param, sucCb, failCb) {
    var data = {};

    if (typeof param === 'string') {
      data.code = param;
    } else {
      if (param.code) {
        data.code = param.code;
      }

      if (param.vuser) {
        data.isgetvuticket = 1;
      }
    }

    $.ajax({
      url: [config.payCgiBaseUrl, 'wx_getuserinfo?otype=json'].join(''),
      dataType: 'jsonp',
      cache: false,
      data: data
    }).done(function (json) {
      if (json && json.result) {
        if (json.result.code === 0) {
          sucCb(json.user);
        } else {
          failCb(json.result.code);
        }
      } else {
        failCb(-404);
      }
    }).fail(function () {
      failCb(-404);
    });
  },

  /**
   * 获取微信绑定QQ号
   * @param {} param {openid:xx}
   * @param {} sucCb 成功回调
   * @param {} failCb 失败回调
   */
  getUin: function getUin(param, suCb, failCb) {
    var openid = param.openid || '';

    if (openid === '') {
      failCb && failCb();
      return;
    }

    var appid = param.appid || config.wxappid;
    var url = ['//pay.video.qq.com/fcgi-bin/wxopenid2uin?openid=', openid, '&appid=', appid, '&otype=json'].join('');
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function success(json) {
        if (json && parseInt(json.result.code) === 0 && json.uin > 0) {
          suCb && suCb(json.uin);
        } else {
          failCb && failCb();
        }
      },
      error: function error() {
        failCb && failCb();
      }
    });
  },
  // 分享--微信、手q、应用宝、app
  setAllShare: function setAllShare(shareParam) {
    var defaultParam = {
      imgUrl: '//i.gtimg.cn/qqlive/images/20140121/hollywood_logo.png',
      title: '腾讯视频VIP影院',
      desc: '享受更好的，因为我是VIP',
      link: window.location.href.replace(/[?&#](code|state|timestamp)=[^&#]+/gi, '')
    };
    var param = $.extend(defaultParam, shareParam);
    param.imgUrl = normalizer(param.imgUrl, false);
    param.link = normalizer(param.link, false);

    if (this.isWeiXin()) {
      this.setShare(param);
    } else if (tenvideo.isTenvideo()) {
      tenvideo.setShare(param);
    } else if (ua.match(/QQ\/([\d.]+)/)) {
      $.getScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
        mqq.data.setShareInfo({
          title: param.title,
          desc: param.desc,
          share_url: param.link,
          image_url: param.imgUrl
        }, function callback(result) {
          if (result.retCode) {
            param.success && param.success();
          } else {
            param.cancel && param.cancel();
          }
        });
      });
    }
  },

  /**
   * 统一的点击按钮引导分享
   * @param shareParam 分享参数
   * @param openShareLayer 打开分享浮层的方法
   * @param closeShareLayer 关闭分享浮层的方法
   */
  unionClickToShare: function unionClickToShare(shareParam, openShareLayer, closeShareLayer) {
    if (!tenvideo.isTenvideo()) {
      openShareLayer && openShareLayer();
    }

    shareParam = $.extend({
      success: function success() {
        if (!tenvideo.isTenvideo()) {
          closeShareLayer && closeShareLayer();
        }
      }
    }, shareParam);
    this.setAllShare(shareParam);

    if (tenvideo.isTenvideo()) {
      tenvideo.openShare();
    }
  },

  /**
   * 设置微信webview标题 ios下需要手动设置，才会更新标题
   * @param title
   */
  setPageTitle: function setPageTitle(title) {
    wx.ready(function () {
      wx.invoke('setPageTitle', {
        title: title
      }, function () {// alert(res.err_msg);
      });
    });
  },

  /**
   *  微信6.5.6版本以上拉起app
   */
  launchApplication: function launchApplication(schemeUrl) {
    var versionStrArr = ua.match(/MicroMessenger\/([\d.]+)/);

    if (versionStrArr && versionStrArr.length === 2 && verCompare('6.5.6', versionStrArr[1]) >= 0) {
      if (ua.indexOf('iPad') !== -1) {
        try {
          window.WeixinJSBridge && WeixinJSBridge.invoke('launchApplication', {
            schemeUrl: schemeUrl
          }, function () {// alert(JSON.stringify(res));
          });
        } catch (e) {
          void 0;
        }
      } else {
        wx.ready(function () {
          wx.invoke('launchApplication', {
            appID: APP_APP_ID,
            extInfo: schemeUrl,
            parameter: schemeUrl
          }, function () {});
        });
      }
    } else {
      location.href = schemeUrl;
    }
  },

  /**
   * 获取设备网络状态，返回网络类型2g，3g，4g，wifi
   * @param {[function]} sucCb 必填
   */
  getNetWorkType: function getNetWorkType(sucCb, failCb) {
    this.weixinReady(function () {
      wx.getNetworkType({
        success: sucCb,
        fail: failCb
      });
    });
  },

  /**
   * 获取定位位置信息
   * @param {number} type 1: wgs84-gps坐标 2: gcj02-火星坐标
   * @callback sucCb 获取成功回调函数
   * @param {sucCb} loc { lat: 纬度，浮点数，范围为90 ~ -90, lon: 经度，浮点数，范围为180 ~ -180, speed: 速度，以米/每秒计, accuracy: 位置精度 }
   * @callback failCb 失败回调函数
   * @param {failCb} err 失败信息
   */
  getLocation: function getLocation(type, sucCb, failCb) {
    var t = parseInt(type) === 2 ? 'gcj02' : 'wgs84';
    this.weixinReady(function () {
      wx.getLocation({
        type: t,
        success: function success(res) {
          var loc = {
            lat: res.latitude,
            lon: res.longitude,
            speed: res.speed,
            accuracy: res.accuracy
          };
          sucCb && sucCb(loc);
        },
        fail: function fail(err) {
          failCb && failCb(err);
        }
      });
    });
  }
};